import { useEffect, useState } from "react";
import { isR2Backend } from "../config/videoBackend";
import { getPlaybackUrl } from "../services/r2Video";

/**
 * Resolve a playable video URL for rendering.
 *
 * - Firebase backend: returns the durable downloadUrl unchanged.
 * - R2 backend: mints a fresh short-lived presigned GET from the storagePath
 *   (R2 key) on mount / when inputs change. Falls back to any stored URL.
 *
 * Returns "" until resolved on R2 so callers can defer rendering the <video>.
 */
export default function useResolvedVideoUrl(storagePath, downloadUrl) {
  const r2 = isR2Backend();
  const [url, setUrl] = useState(r2 ? "" : downloadUrl || "");

  useEffect(() => {
    let cancelled = false;
    if (!r2) {
      setUrl(downloadUrl || "");
      return undefined;
    }
    if (!storagePath) {
      setUrl(downloadUrl || "");
      return undefined;
    }
    getPlaybackUrl(storagePath)
      .then((u) => {
        if (!cancelled) setUrl(u);
      })
      .catch(() => {
        if (!cancelled) setUrl(downloadUrl || "");
      });
    return () => {
      cancelled = true;
    };
  }, [r2, storagePath, downloadUrl]);

  return url;
}
